<template>
  <div class="vehicles-slider">
    <b-carousel
      id="carousel-fade"
      fade
      indicators
      :interval="3000">
      <b-carousel-slide :img-src="require('@/assets/pickup.png')" img-alt="Pickup"></b-carousel-slide>
      <b-carousel-slide :img-src="require('@/assets/sport.png')" img-alt="Voiture de sport"></b-carousel-slide>
      <b-carousel-slide :img-src="require('@/assets/camion.png')" img-alt="Camion"></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
  export default {
    name: 'VehiculesSlider',
  };
</script>

<style scoped>
  .vehicles-slider {
    border-radius: var(--radius);
    overflow: hidden;
    border: 1px solid var(--border);
    background: linear-gradient(180deg, var(--surface), var(--bg-elev));
    box-shadow: var(--shadow-card);
    padding: 1rem;
  }
  .vehicles-slider ::v-deep .carousel-item img {
    width: 100%;
    height: clamp(200px, 30vw, 360px);
    object-fit: contain;
  }
  .vehicles-slider ::v-deep .carousel-indicators li {
    background-color: var(--gold);
  }
</style>
